import { Column, FilterFn, Table } from "@tanstack/react-table";

interface FilterProps<TData extends object> {
  column: Column<TData, unknown>;
  table: Table<TData>;
}

export function Filter<TData extends object>({ column, table }: FilterProps<TData>) {
  const columnFilterValue = column.getFilterValue();
  return (
    <div className="px-2">
      <input
        type="text"
        value={(columnFilterValue ?? "") as string}
        onChange={(e) => column.setFilterValue(e.target.value)}
        placeholder={`Search ${column.id}...`}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 w-full"
      />
    </div>
  );
}

export const fuzzyFilter: FilterFn<any> = (row, columnId, value) => {
  const cellValue = String(row.getValue(columnId));
  const filterValue = String(value);
  return cellValue.includes(filterValue);
};
